module.exports = __webpack_public_path__ + "static/media/MV.d22a3fd0.png";